var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "53px",
    viewBox: "0 0 52 53",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "File---Upload",
    stroke: "none",
    strokeWidth: 1,
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(6.500000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "file-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.9166328,13.25 L27.0833672,13.25 C26.4853672,13.25 26,12.753125 26,12.1457988 L26,1.10420117 C26,0.494701172 25.5146328,0 24.9166328,0 L3.25,0 C1.45813281,0 0,1.48617383 0,3.3125 L0,49.6875 C0,51.5138262 1.45813281,53 3.25,53 L35.75,53 C37.5418672,53 39,51.5138262 39,49.6875 L39,14.3542012 C39,13.7447012 38.5146328,13.25 37.9166328,13.25 Z M36.8333672,49.6875 C36.8333672,50.2948262 36.348,50.7917012 35.75,50.7917012 L3.25,50.7917012 C2.652,50.7917012 2.16663281,50.2948262 2.16663281,49.6875 L2.16663281,3.3125 C2.16663281,2.70517383 2.652,2.20829883 3.25,2.20829883 L23.8333672,2.20829883 L23.8333672,12.1457988 C23.8333672,13.972125 25.2915,15.4582988 27.0833672,15.4582988 L36.8333672,15.4582988 L36.8333672,49.6875 L36.8333672,49.6875 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.6815,13.574625 L25.6815,0.324625 C25.259,-0.106 24.5721328,-0.106 24.1496328,0.324625 C23.7271328,0.75525 23.7271328,1.45532617 24.1496328,1.88595117 L37.1496328,15.1359512 C37.362,15.350125 37.6392656,15.4584023 37.9166328,15.4584023 C38.194,15.4584023 38.4712656,15.3502285 38.6815,15.1359512 C39.104,14.7053262 39.104,14.00525 38.6815,13.574625 Z",
    id: "Path"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileUpload);
export default __webpack_public_path__ + "static/media/File - Upload.b620d246e8e6f67158098281f0c72c98.svg";
export { ForwardRef as ReactComponent };